import api from './client';

/**
 * Phase 38A.6 · Admin O2O API client.
 * All endpoints require `is_admin=true`.
 */

export const adminO2OSearch = async (q) => {
  const res = await api.get('/admin/o2o/search', { params: { q } });
  return res.data;
};

export const adminListDisputes = async ({ state = null, skip = 0, limit = 50 } = {}) => {
  const params = { skip, limit };
  if (state) params.state = state;
  const res = await api.get('/admin/o2o/disputes', { params });
  return res.data;
};

export const adminDisputeDetail = async (disputeId) => {
  const res = await api.get(`/admin/o2o/disputes/${disputeId}`);
  return res.data;
};

export const adminCloseDispute = async (disputeId, { resolution, adminNotes, issueRefund = false }) => {
  const res = await api.post(`/admin/o2o/disputes/${disputeId}/close`, {
    resolution,
    admin_notes: adminNotes,
    issue_refund: issueRefund,
  });
  return res.data;
};

export const adminRecordingSignedUrl = async (disputeId, { reason }) => {
  const res = await api.post(`/admin/o2o/disputes/${disputeId}/recording-url`, {
    reason,
  });
  return res.data;
};

export const adminForceClose = async (o2oSessionId, { reason, issueRefund = true }) => {
  const res = await api.post(`/admin/o2o/sessions/${o2oSessionId}/force-close`, {
    reason,
    issue_refund: issueRefund,
  });
  return res.data;
};

export const adminRefundOverride = async (o2oSessionId, { reason }) => {
  const res = await api.post(`/admin/o2o/sessions/${o2oSessionId}/refund-override`, {
    reason,
  });
  return res.data;
};

export const adminReliabilityStats = async ({ scope = 'creator', q = null, limit = 20 } = {}) => {
  const params = { scope, limit };
  if (q) params.q = q;
  const res = await api.get('/admin/o2o/stats/reliability', { params });
  return res.data;
};

export const adminAuditTimeline = async (sessionId) => {
  const res = await api.get(`/admin/o2o/audit/${sessionId}`);
  return res.data;
};
